import { IconButton } from "@App/Components/common/IconButton/IconButton";
import type { Service } from "@App/types";
import { getServiceIcon } from "@App/utils/getServiceIcon";
import type { ServiceGroup } from "@App/utils/groupServices";
import type { FunctionComponent } from "react";

export type CategoryServiceStepProps = {
  category: ServiceGroup;
  onSelectService: (service: Service) => void;
};

/**
 * DHL's second step: the concrete services behind the category picked in the first one.
 */
export const CategoryServiceStep: FunctionComponent<CategoryServiceStepProps> = ({
  category,
  onSelectService,
}: CategoryServiceStepProps) => {
  return (
    <div className="overflow-hidden">
      <div className="md:w-fit ease-in-out grid grid-cols-1 xs:grid-cols-2 gap-2 mb-4 mt-4 w-full">
        {category.services.map((service) => (
          <IconButton
            key={service.id}
            title={service.pivot.display_name ? service.pivot.display_name : service.name}
            subtitle={service.pivot.subtitle}
            onClick={() => onSelectService(service)}
            icon={getServiceIcon(service.pivot.icon)}
          />
        ))}
      </div>
    </div>
  );
};
